(function installAskAvantreePreviewHandoff(global) {
  "use strict";

  var root = document.querySelector("[data-ask-avantree-root]");
  if (!root || !global.AskAvantreeHandoff) return;
  root.dataset.askHandoffAdapter = "true";

  var messages = root.querySelector("[data-ask-messages]");
  var conversation = root.querySelector("[data-ask-conversation]");
  var activeTraceId = null;
  var adapter = null;
  var stateRow = null;
  var stateText = null;
  var emailForm = null;
  var messagingCopy = [
    "Connecting you to an agent...",
    "You're in the queue. An agent will join shortly.",
    "An agent has joined the conversation.",
  ];

  function scrollToLatest() {
    global.requestAnimationFrame(function () {
      conversation.scrollTop = conversation.scrollHeight;
    });
  }

  function findExistingState(message) {
    var paragraphs = messages.querySelectorAll(".ask-avantree__message--assistant > p");
    for (var index = paragraphs.length - 1; index >= 0; index -= 1) {
      if (paragraphs[index].textContent.trim() === message) return paragraphs[index];
    }
    return null;
  }

  function createState(message) {
    var existing = findExistingState(message);
    if (existing) {
      stateText = existing;
      stateRow = existing.closest(".ask-avantree__message-row");
      stateRow.dataset.askMessagingState = "true";
      return;
    }

    stateRow = document.createElement("div");
    stateRow.className = "ask-avantree__message-row ask-avantree__message-row--assistant";
    stateRow.dataset.askMessagingState = "true";
    var avatarTemplate = root.querySelector("[data-ask-avatar-template]");
    if (avatarTemplate && avatarTemplate.content) stateRow.appendChild(avatarTemplate.content.cloneNode(true));

    var body = document.createElement("div");
    body.className = "ask-avantree__message-body";
    var item = document.createElement("div");
    item.className = "ask-avantree__message ask-avantree__message--assistant";
    stateText = document.createElement("p");
    stateText.textContent = message;
    item.appendChild(stateText);
    body.appendChild(item);
    stateRow.appendChild(body);
    messages.appendChild(stateRow);
  }

  function removeDuplicateStates() {
    messages.querySelectorAll(".ask-avantree__message-row--assistant").forEach(function (row) {
      if (row === stateRow) return;
      var paragraph = row.querySelector(".ask-avantree__message--assistant > p");
      if (paragraph && messagingCopy.indexOf(paragraph.textContent.trim()) !== -1) row.remove();
    });
  }

  function setState(message, status) {
    var text = message || (status === "connected" ? "An agent has joined the conversation." : status === "failed" ? "We couldn't connect you. Please try again or email support@ivintree.com." : "Connecting you to an agent...");
    if (!stateText) createState(text);
    stateText.textContent = status === "connected" ? "Connected — " + text : text;
    stateRow.dataset.askMessagingStatus = status || "unknown";
    messages.hidden = false;
    global.setTimeout(removeDuplicateStates, 0);
    scrollToLatest();
  }

  function renderEmailForm(message) {
    if (emailForm && emailForm.isConnected && !emailForm.hidden) return;
    if (emailForm) emailForm.remove();
    emailForm = document.createElement("form");
    emailForm.className = "ask-avantree__followup";
    emailForm.dataset.askPreviewHandoffEmail = "true";

    var title = document.createElement("strong");
    title.textContent = "Continue with Avantree Support";
    emailForm.appendChild(title);

    var copy = document.createElement("p");
    copy.textContent = message || "Our agents are offline. Please enter your email so our support team can follow up.";
    emailForm.appendChild(copy);

    var email = document.createElement("input");
    email.type = "email";
    email.required = true;
    email.autocomplete = "email";
    email.placeholder = "Email address";
    email.setAttribute("aria-label", "Email address");
    emailForm.appendChild(email);

    var consentLabel = document.createElement("label");
    consentLabel.className = "ask-avantree__followup-consent";
    var consent = document.createElement("input");
    consent.type = "checkbox";
    consent.required = true;
    consent.className = "ask-avantree__consent-checkbox";
    consentLabel.appendChild(consent);
    var consentBox = document.createElement("span");
    consentBox.className = "ask-avantree__consent-box";
    consentBox.setAttribute("aria-hidden", "true");
    consentLabel.appendChild(consentBox);
    consentLabel.appendChild(document.createTextNode("I agree that Avantree may use this email to send this support follow-up."));
    emailForm.appendChild(consentLabel);

    var submit = document.createElement("button");
    submit.type = "submit";
    submit.textContent = "Send conversation to Support";
    emailForm.appendChild(submit);

    var formStatus = document.createElement("p");
    formStatus.className = "ask-avantree__followup-status";
    formStatus.setAttribute("aria-live", "polite");
    emailForm.appendChild(formStatus);

    emailForm.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!emailForm.reportValidity()) return;
      submit.disabled = true;
      formStatus.textContent = "Sending your conversation...";
      adapter.submitEmail(email.value).then(function (result) {
        if (result.emailValidation === "invalid") {
          submit.disabled = false;
          formStatus.textContent = result.customerMessage || "Please enter a valid email address.";
          return;
        }
        emailForm.hidden = true;
        setState(result.customerMessage || "Thanks. Your request has been sent to our support team.", "sent");
      }).catch(function () {
        submit.disabled = false;
        formStatus.textContent = "We couldn't send your request. Please try again or email support@ivintree.com.";
      });
    });

    messages.appendChild(emailForm);
    scrollToLatest();
  }

  function handleState(state) {
    var legacyForm = messages.querySelector("[data-ask-followup]");
    if (legacyForm) legacyForm.remove();
    if (state.emailRequired) {
      if (stateRow) stateRow.remove();
      stateRow = null;
      stateText = null;
      renderEmailForm(state.message);
      return;
    }
    setState(state.message, state.status);
  }

  function startHandoff() {
    var traceId = root.dataset.lastCanonicalTraceId;
    if (root.dataset.lastCanonicalDecision !== "HANDOFF_REQUIRED" || !traceId || traceId === activeTraceId) return;
    if (emailForm) emailForm.remove();
    emailForm = null;
    delete root.dataset.askHandoffDiagnosticPhase;
    delete root.dataset.askHandoffDiagnosticHistory;
    delete root.dataset.askHandoffProviderConversationId;
    delete root.dataset.askHandoffDiagnosticHttpStatus;
    delete root.dataset.askHandoffDiagnosticReason;
    try {
      if (adapter) adapter.destroy();
      adapter = global.AskAvantreeHandoff.create({
        endpoint: root.dataset.followupUrl,
        sessionId: global.sessionStorage.getItem("askAvantreeSessionId") || "",
        canonicalTraceId: traceId,
        locale: root.dataset.activeLocale || document.documentElement.lang || "en-US",
        onState: handleState,
        onConversationId: function (id) { root.dataset.askHandoffProviderConversationId = id; },
        onDiagnostic: function (diagnostic) {
          root.dataset.askHandoffDiagnosticPhase = diagnostic.phase;
          var history = root.dataset.askHandoffDiagnosticHistory;
          root.dataset.askHandoffDiagnosticHistory = (history ? history.split(",").slice(-19).join(",") + "," : "") + diagnostic.phase;
          if (diagnostic.httpStatus) root.dataset.askHandoffDiagnosticHttpStatus = String(diagnostic.httpStatus);
          if (diagnostic.reason) root.dataset.askHandoffDiagnosticReason = diagnostic.reason;
          global.console.info("[Ask Avantree handoff] " + JSON.stringify(diagnostic));
        },
      });
      activeTraceId = traceId;
      adapter.start().catch(function () {
        setState("We couldn't connect you. Please try again or email support@ivintree.com.", "failed");
      });
    } catch (error) {
      if (!root.dataset.askHandoffDiagnosticPhase) root.dataset.askHandoffDiagnosticPhase = "adapter_create";
      global.console.warn("[Ask Avantree handoff] " + JSON.stringify({ phase: root.dataset.askHandoffDiagnosticPhase }));
      setState("We couldn't connect you. Please try again or email support@ivintree.com.", "failed");
    }
  }

  new MutationObserver(startHandoff).observe(root, {
    attributes: true,
    attributeFilter: ["data-last-canonical-decision", "data-last-canonical-trace-id"],
  });
  startHandoff();
})(window);
